import React from 'react';

import { Button, Center, Flex, Heading, Highlight, Icon, List, Text, Timeline } from '@chakra-ui/react';
import { FaAngleDown, FaArrowRightLong, FaAward, FaBolt, FaBuilding, FaCalendarCheck, FaEllipsis, FaFileLines, FaLightbulb, FaPhone, FaUser } from "react-icons/fa6";

import './styles/HowItWorksComponent.css';

function HowItWorksComponent() {

    return (
        // Need to use this trick so we jump to the offset of navigation bar

        // Desktop only view
        <div style={{
            paddingTop: '69px',
            marginTop: '-69px',
        }}
        id='howdoesitwork'>
            <Flex className="how_it_works_component__parent" direction='column' gap='12'>
                <Heading color='black' fontWeight='bold' size='4xl'>
                    <Flex gap='2' justify='center'>
                        <FaLightbulb color='#FB5383' style={{marginTop: "4px"}} />
                        How does it work?
                    </Flex>
                </Heading>
                <Flex gap='20' justify='center' style={{marginTop: '40px'}}>
                    <Timeline.Root maxW="450px" size='xl' style={{marginTop: "30px"}}>
                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaUser />
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold'>Submit your information below</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                One of our expert negotiators will reach out within 1 business day to connect
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaPhone />
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold' textAlign='left'>Connect with your personal coach in a 1:1 intro call</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                Discuss your current situation and come up with a plan of attack together
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaBuilding/>
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold' textAlign='left'>Begin negotiations with any/all Companies</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                Your personal coach will be with you along every step of the way, guiding you on the best way to navigate through the process
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaAward />
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold' textAlign='left'>Sign your new offer!</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                You're all set! We wish you the best and congratulate you on your hard work well done
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>
                    </Timeline.Root>
                    <Flex className='how_it_works_component__whats_included_parent' direction='column' gap='6' maxW='325px'>
                        <Heading color='black' fontWeight='bold' size='2xl' style={{marginTop: "10px"}}>
                            <Highlight query='included' styles={{color: '#FB5383'}}>
                                What's included?
                            </Highlight>
                        </Heading>
                        <List.Root gap="4" variant="plain">
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaBolt/>
                                </List.Indicator>
                                Guaranteed increase or services free
                            </List.Item>
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaPhone/>
                                </List.Indicator>
                                Up to 3 personal 1:1 video calls and unlimited email support
                            </List.Item>
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaCalendarCheck />
                                </List.Indicator>
                                1 month support after offer acceptance
                            </List.Item>
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaFileLines/>
                                </List.Indicator>
                                Free e-resources on the best tips and tricks for mastering negotiating
                            </List.Item>
                        </List.Root>
                    </Flex>
                </Flex>
                <Flex justify='center' style={{marginTop: '40px'}}>
                    <Button backgroundColor='#FB5383' className='button' color='white' fontWeight='bold' rounded='md' size='lg' onMouseDown={() => {
                        window.location.href='#contactus'
                    }}>
                        Connect with an Expert <FaArrowRightLong style={{height: "15px", width: "15px"}} />
                    </Button>
                </Flex>
            </Flex>

            {/* Mobile only view */}
            <Flex className="how_it_works_component__mobile_parent" direction='column' gap='12'>
                <Heading color='black' fontWeight='bold' size='3xl'>
                    <Flex gap='2' justify='center'>
                        <FaLightbulb color='#FB5383' style={{marginTop: "4px"}} />
                        How does it work?
                    </Flex>
                </Heading>
                <Flex gap='2' direction='column' justify='center'>
                    <Timeline.Root maxW="450px" size='xl' style={{marginTop: "50px"}}>
                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaUser />
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold'>Submit your information below</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                One of our expert negotiators will reach out within 1 business day to connect
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaPhone />
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold' textAlign='left'>Connect with your personal coach in a 1:1 intro call</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                Discuss your current situation and come up with a plan of attack together
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaBuilding/>
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold' textAlign='left'>Begin negotiations with any/all Companies</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                Your personal coach will be with you along every step of the way, guiding you on the best way to navigate through the process
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>

                        <Timeline.Item>
                            <Timeline.Connector>
                            <Timeline.Separator />
                            <Timeline.Indicator backgroundColor='#FB5383' color='white'>
                                <FaAward />
                            </Timeline.Indicator>
                            </Timeline.Connector>
                            <Timeline.Content>
                            <Timeline.Title color='black' fontSize='18px' fontWeight='bold' textAlign='left'>Sign your new offer!</Timeline.Title>
                            <Timeline.Description color='black' textAlign='left'>
                                You're all set! We wish you the best and congratulate you on your hard work well done
                            </Timeline.Description>
                            </Timeline.Content>
                        </Timeline.Item>
                    </Timeline.Root>
                    
                    <Center>
                        <Icon color='#FB5383'>
                            <FaEllipsis/>
                        </Icon>
                    </Center>

                    <Flex className='how_it_works_component__whats_included_mobile_parent' direction='column' gap='6' style={{marginTop: '20px'}}>
                        <Heading color='black' fontWeight='bold' size='2xl' style={{marginTop: "10px"}}>
                            <Highlight query='included' styles={{color: '#FB5383'}}>
                                What's included?
                            </Highlight>
                        </Heading>
                        <List.Root gap="4" variant="plain" style={{marginTop: '10px'}}>
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaBolt/>
                                </List.Indicator>
                                Guaranteed increase or services free
                            </List.Item>
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaPhone/>
                                </List.Indicator>
                                Up to 3 personal 1:1 video calls and unlimited email support
                            </List.Item>
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaCalendarCheck />
                                </List.Indicator>
                                1 month support after offer acceptance
                            </List.Item>
                            <List.Item color='#3e3e3e' fontWeight='bold' gap='2' textAlign='left'>
                                <List.Indicator asChild color="#FB5383" style={{marginTop: "2.5px"}}>
                                    <FaFileLines/>
                                </List.Indicator>
                                Free e-resources on the best tips and tricks for mastering negotiating
                            </List.Item>
                        </List.Root>
                    </Flex>
                </Flex>
                <Flex justify='center' style={{marginTop: '25px'}}>
                    <Button backgroundColor='#FB5383' className='button' color='white' fontWeight='bold' rounded='md' size='lg' onMouseDown={() => {
                        window.location.href='#contactus'
                    }}>
                        Connect with an Expert <FaArrowRightLong style={{height: "15px", width: "15px"}} />
                    </Button>
                </Flex>
            </Flex>
        </div>
    );
}

export default HowItWorksComponent;
